import { connect, ConnectedProps } from 'react-redux';
import SavedFilterChip from '../saved-filter-chip';
import { getTeamsRequest } from '../../../../../../../settings/components/users-and-teams/extra-actions';
import {
  resetDeleteSavedViewRequest,
  resetPinUnpinSavedFilterRequest,
  resetUpdateSavedFilterRequest,
} from '../../../../../../prospect-slice';
import {
  deleteSavedViewRequest,
  getFilterViewListRequest,
  pinUnpinSavedFilterRequest,
  updateSavedFilterRequest,
} from '../../../../../../extra-actions';
import { PinUnpinActionType, SavedFilter } from '../../../../../../types';
import { RootState } from '../../../../../../../../store/root-reducer';

const mapStateToProps = (state: RootState) => ({
  teamsList: state.usersAndTeams.teams,
  getTeamsListRequestStatus: state.usersAndTeams.getTeamsRequest.status,

  pinUnpinSavedFilterRequestStatus:
    state.prospect.pinUnpinSavedFilterRequest.status,
  updateSavedFilterRequestStatus:
    state.prospect.updateSavedFilterRequest.status,
  updateSavedFilterRequestMessage:
    state.prospect.updateSavedFilterRequest.message,
  deleteSavedViewRequestStatus: state.prospect.deleteSavedViewRequest.status,
  deleteSavedViewRequestMessage: state.prospect.deleteSavedViewRequest.message,
  activeViewId: state.prospect.activeViewId,
});

const mapDispatchToProps = {
  sendPinUnpinSavedFilterRequest: (
    viewId: number,
    action: PinUnpinActionType,
  ) => pinUnpinSavedFilterRequest({ viewId, action }),
  sendUpdateSavedFilterRequest: (
    viewId: number,
    payload: { filterName: string; isShared: boolean; teamIds: number[] },
  ) => updateSavedFilterRequest({ viewId, payload }),
  sendDeleteSavedViewRequest: (viewId: number) =>
    deleteSavedViewRequest({ viewId }),

  sendGetTeamsListRequest: () =>
    getTeamsRequest({
      pageNum: 1,
      pageSize: 500,
    }),
  getFilterViewListRequest: () => getFilterViewListRequest({}),

  resetPinUnpinSavedFilterRequest: () => resetPinUnpinSavedFilterRequest(),
  resetUpdateSavedFilterRequest: () => resetUpdateSavedFilterRequest(),
  resetDeleteSavedViewRequest: () => resetDeleteSavedViewRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  selectedSavedViewId: number;
  filterId: number;
  isCountLoading: boolean;
  onFilterApplied: VoidFunction;
  onRemoveFilter: (isFromAllProspect?: boolean) => void;
  handlePinUnpin: (viewId: number, action: PinUnpinActionType) => void;
  prospectCount: number;
  label: string;
  filter: SavedFilter;
  selectedSavedView: SavedFilter | null;
};

export default connector(SavedFilterChip);
